<template>
  <ul class="list-icons">
    <li v-if="showReadingIcon(subtest)">
      <img src="/images/icon1.svg" alt="reading">
    </li>
    <li v-if="showListeningIcon(subtest)">
      <img src="/images/icon2.svg" alt="listening">
    </li>
    <li v-if="showWritingIcon(subtest)">
      <img src="/images/icon3.svg" alt="writing">
    </li>
    <li v-if="showSpeakingIcon(subtest)">
      <img src="/images/icon4.svg" alt="speaking">
    </li>
  </ul>
</template>

<script>
export default {
  props: ['subtest'],

  methods: {
    showReadingIcon (subtest) {
      return [1, 3, 5].includes(subtest.subtest_type_id);
    },
    showListeningIcon (subtest) {
      return [2, 3, 5].includes(subtest.subtest_type_id);
    },
    showWritingIcon (subtest) {
      return [3, 5].includes(subtest.subtest_type_id);
    },
    showSpeakingIcon (subtest) {
      return [4, 5].includes(subtest.subtest_type_id);
    },
  }
};
</script>

<style scoped>

</style>
